import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { iconPickerField } from "@/puck/fields/iconPickerField";
import { GPT_PAGE_MOCKUP_DEFAULT_PROPS } from "@/puck/landing/gptPageMockupBlock";
import { LpGptPageMockupBlock } from "@/puck/landingBlocks";

const GPT_PAGE_MOCKUP_FIELDS = {
  greeting: { type: "text" as const, contentEditable: true },
  inputPrompts: {
    type: "array" as const,
    label: "Animated prompt examples",
    getItemSummary: (item: { text: string }) => item.text,
    defaultItemProps: { text: "Ask Gail anything…" },
    arrayFields: {
      text: { type: "text" as const, contentEditable: true },
    },
  },
  modelLabel: { type: "text" as const, label: "Model selector label" },
  searchPlaceholder: {
    type: "text" as const,
    label: "Sidebar search placeholder",
  },
  suggestions: {
    type: "array" as const,
    label: "Suggestion cards",
    getItemSummary: (item: { title: string }) => item.title,
    defaultItemProps: {
      icon: "file-lines",
      title: "Card title",
      description: "Card description",
    },
    arrayFields: {
      icon: iconPickerField("Icon"),
      title: { type: "text" as const, contentEditable: true },
      description: { type: "textarea" as const, contentEditable: true },
    },
  },
  zoom: {
    type: "select" as const,
    label: "Zoom",
    options: [
      { label: "None (100%)", value: "none" },
      { label: "90%", value: "90" },
      { label: "85%", value: "85" },
      { label: "80%", value: "80" },
      { label: "75%", value: "75" },
      { label: "50%", value: "50" },
    ],
  },
};

/** Content-category alias for nesting the GPT mockup inside column slots and templates. */
export const gptPageMockupContentConfigs: Pick<
  LandingComponents,
  "GptPageMockup"
> = {
  GptPageMockup: {
    label: "GPT page mockup",
    fields: GPT_PAGE_MOCKUP_FIELDS,
    defaultProps: GPT_PAGE_MOCKUP_DEFAULT_PROPS,
    render: LpGptPageMockupBlock,
  },
};
